<template>
    <main id="main-content" class="collection">
        <div v-html="content_text">{{ content_text }}</div>
        <div class="collections-navigator">
            <div class="flash">
                <a class="next" :href="next_prev_navigation.next.link">
                    <div class="image" :style="style">

                    </div>
                    <div class="desc">
                        <p class="note">Zobacz pozostałe kolekcje</p>
                        <p class="collection-name">{{ next_prev_navigation.next.name }}</p>
                        <div class="arrow">
                            <svg xmlns="http://www.w3.org/2000/svg" width="205.564" height="32.601" viewBox="0 0 205.564 32.601">
                                <g id="arrowW" transform="translate(-742.5 -8478.7)">
                                    <path id="Path_357" data-name="Path 357" d="M2871,8798.333h205" transform="translate(-2128.5 -303)" fill="none" stroke="#fff4e6" stroke-width="2"/>
                                    <g id="Group_415" data-name="Group 415" transform="translate(931.5 8479.407)">
                                        <line id="Line_10" data-name="Line 10" x2="15.857" y2="15.857" fill="none" stroke="#fff4e6" stroke-width="2"/>
                                        <line id="Line_11" data-name="Line 11" x1="15.857" y2="15.857" transform="translate(0 15.329)" fill="none" stroke="#fff4e6" stroke-width="2"/>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <Gallery v-if="gallery_images_ids" v-bind:images_ids="gallery_images_ids" />
    </main>
</template>

<script>
    import axios from "axios";
    import Gallery from "@/components/Gallery.vue";

    const GALLERY_API = window.APP_INFO.init.REST_PREFIX + "/wp-json/gallery/v1/";

    export default {
        name: "Collection",
                data() {
            return {
                gallery_images_ids: null,
                has_selectors_class: false,
                template2: "none",
                style: 'background-image: url("' + this.next_prev_navigation.next.thumbnail + '")',
                trans: {
                    click_to_open_gallery: window.APP_INFO.trans.click_to_open_gallery,
                },
            };
        },
        props: {
            content_text: {
                type: String,
                        required: false
            },
            content_title: {
                type: String,
                        required: false
            },
            next_prev_navigation: {
                type: Array,
                        required: false
            }
        },
        components: {
            Gallery,
        },
        /*computed:{
         services(){ return this.services;}
         },*/

        watch: {
            services() {
                return this.services;
            }
        },
        updated() {
            console.log('Content.vue updated')
            console.log(this.content_text);
            console.log(this.next_prev_navigation)
            // console.log(this.services);
            if (this.services != null && this.services.indexOf("freshmail") > -1) {
                //console.log("fm here youpiiii");
            }
            this.bindGalleries(document.querySelectorAll("[data-load-gallery]"));
        },
        mounted() {
            console.log('Content.vue collection mounted')
            console.log(this.next_prev_navigation)
            this.bindGalleries(document.querySelectorAll("[data-load-gallery]"));
            // const vm = this;
            // vm.showVideo(vm.content.page)
        },
        methods: {
            bindGalleries($links) {

                if ($links != null) {
                    console.log('bind gallery')
                    let i;
                    let vm = this;
                    for (i = 0; i < $links.length; i++) {
                        $links[i].addEventListener("click", function (e) {
                            console.log('click')
                            e.preventDefault();

                            let collection_id = e.currentTarget.getAttribute(
                                    "data-load-gallery"
                            );
                            axios
                                    .get(`${GALLERY_API}collections/` + collection_id)
                            .then(function (response) {
                                // console.log(response.data.images_ids)
                                if (response.data.images_ids != null) {
                                    vm.gallery_images_ids = response.data.images_ids;
                                } else {
                                    vm.gallery_images_ids = null;
                                }
                            });
                            return false;
                        });
                    }
                }
            },
        }
    };
</script>